import { Button, Card, Form, Input, Modal, Select } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import ChequeService from "../../services/cheque.service";
import { allowOnlyAlphaNumerics, allowOnlyAlphaNumericsShouldNotStartWithSpace } from "../../services/common.service";
import CommonOtp from "../../components/otp";
import { CONFIG } from "../../environment";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";

export default function StopCheque({
  selectedDetails = {},
  setVisible,
  setRefresh,
  dataSource,
}) {
  const [form] = Form.useForm();
  const [visibleOtp, setVisibleOtp] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [visibleSuccess, setVisibleSuccess] = useState(false);
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");

  const onVerify = useCallback(
    async (values) => {
      try {
        setFormDetails(values);
        setVisible(false);
        const response = await ChequeService.stopChequeverify({
          amount: selectedDetails?.chequeAmt,
          brnCode: selectedDetails?.accountNo.slice(0, 4),
          effectiveDate: dayjs(new Date()),
          startChequeNumber: selectedDetails?.chequeNo,
          endChequeNumber: selectedDetails?.chequeNo,
          otp: CONFIG?.DEFAULT_OTP,
          srcAccount: selectedDetails?.accountNo,
          //  chequeNumber: selectedDetails?.chequeNo,
          reason: values.reason,
          remarks: values?.remarks,
          requestType: "Individual Cheque",
        });

        if (response.status === 200) {
          if (response.data["data"]["otpEnable"] === true) {
            setVisibleOtp(true);
          } else {
            onConfirm({ ...values, otp: CONFIG?.DEFAULT_OTP });
          }
        }
      } catch (error) {}
    },
    [selectedDetails]
  );

  const onConfirm = useCallback(
    async (values) => {
      try {
        const response = await ChequeService.stopChequeConfirm({
          amount: selectedDetails?.chequeAmt,
          brnCode: selectedDetails?.accountNo.slice(0, 4),
          effectiveDate: dayjs(new Date()),
          startChequeNumber: selectedDetails?.chequeNo,
          endChequeNumber: selectedDetails?.chequeNo,
          srcAccount: selectedDetails?.accountNo,
          //  chequeNumber: selectedDetails?.chequeNo,
          noOfLeaves: 1,
          reason: formDetails.reason,
          remarks: formDetails?.remarks,
          otp: values?.otp,
          stopPaymentType: "Individual Cheque",
          enabledTOTP: values?.enabledTOTP,
        });
        if (response.status === 200) {
          setMessage(response.data["data"]["message"]);
          setVisibleOtp(false);
          setVisibleSuccess(true);
          setOtp("");
        }
      } catch (error) {
        setOtp("");
      }
    },
    [selectedDetails, formDetails]
  );

  function renderForm() {
    return (
      <div>
        <p>Are you sure you want to stop this cheque? Please enter reason</p>
        <Form form={form} layout="vertical" onFinish={onVerify}>
          <Form.Item
            label={t("pages.card_settings.reason", {
              defaultValue: "Reason",
            })}
            name="reason"
            rules={[{ required: true, message: "Reason is required" }]}
          >
            <Select
              placeholder={t("pages.card_settings.reason", {
                defaultValue: "Reason",
              })}
              size="large"
            >
              {dataSource.map((option, idx) => (
                <Select.Option key={idx} value={option?.reason}>
                  {option?.reason}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={t("common.remarks", { defaultValue: "Reason" })}
            name="remarks"
            rules={[{ required: true, message: "Remarks are required" }]}
          >
            <Input
              onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
              size="large"
              placeholder={t("common.remarks", { defaultValue: "Reason" })}
              maxLength={30}
            />
          </Form.Item>
          <div align="right" className="mt-3">
            <Button type="link" onClick={() => setVisible(false)}>
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button type="primary" htmlType="submit">
              Stop this Cheque
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  return (
    <>
      <div>{renderForm()}</div>
      <Modal
        closable={false}
        maskClosable={false}
        open={visibleOtp}
        footer={null}
        width={480}
        mask={true}
      >
        <CommonOtp
          otp={otp}
          setOtp={setOtp}
          onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
          handleResendOtp={() => onVerify(formDetails)}
          cancelTransaction={() => {
            setVisibleOtp(false);
            setOtp("");
          }}
        />
      </Modal>

      <Modal
        title={""}
        open={visibleSuccess}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setRefresh(false);
                setVisibleSuccess(false);
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
